import { Link } from 'react-router-dom';

import market from '../../assets/images/market.png'
import league from '../../assets/images/league.png'
import engine from '../../assets/images/engine.png'

import Point from './Point/Point';
import PrimaryCTA from '../Buttons/PrimaryCTA/PrimaryCTA';

import styles from './ExplorationCard.module.css';


const ExplorationCard = props => {

	const points = props.points.map(point=>{return <Point point={point} />});

	let image = <img src={market} alt='Political Prediction Markets' className={styles.Image} />
	if(props.img === 'league') image = <img src={league} alt='Politgical Prediction Leagues' className={styles.Image} />
	if(props.img === 'engine') image = <img src={engine} alt='AI and Expert Powered Prediction Engine' className={styles.Image} />

	return (
		<div className={styles.Card}>
			<div className='d-flex align-items-stretch justify-content-between'>
				<div className='me-lg-3'>
					<h3 className={`${styles.Title} text-center text-lg-start`}>{props.title}</h3>
					<div className='d-lg-none text-center'>{image}</div>
					{points}
					<div className='text-center text-lg-start'>
						<Link to='/interest'><PrimaryCTA linkTo='/interest'>I'm Interested</PrimaryCTA></Link>
					</div>
				</div>
				<div className='d-none d-lg-block'>{image}</div>
			</div>			
		</div>
	)
}

export default ExplorationCard;